<template>
  <a-button-group :class="['op-group', $attrs.class]">
    <a-tooltip
      placement="top"
      :title="$t('fu-zhi-dao-ge-ren-kong-jian')"
      :get-popup-container="getPopupContainer"
    >
      <a-button class="btn-copy" @click="handleCopy">
        <iconpark-icon class="icon" name="card-op-copy"></iconpark-icon>
      </a-button>
    </a-tooltip>
    <BtnDelete class="btn-delete">
      <iconpark-icon class="icon" name="card-op-delete"></iconpark-icon>
    </BtnDelete>
  </a-button-group>
</template>

<script lang="ts" setup>
import { getPopupContainer } from './utils'

import BtnDelete from './btn-delete.vue'
import type { Template } from '~/api/interface'
const ctx: any = inject('personal-page-ctx')
const cardItem = inject<Template>('card-item')

const handleCopy = () => {
  cardItem ? ctx.actionCopy(cardItem) : ctx.actionCopy(undefined)
}
</script>

<style lang="scss" scoped>
.icon {
  font-size: 18px;
}
</style>

<style lang="scss" scoped>
.op-group {
  flex: 1;
  &::v-deep(button) {
    flex: 1;
    padding-top: 6px;
    border-radius: 6px;
    color: var(--text-1-70);
  }
}
</style>
